import React from "react";
import { Link, Redirect, Route, Switch, withRouter } from "react-router-dom";
//import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import PasswordChange from "./PasswordChange";
import Login from "./Login";
import { Helmet } from "react-helmet";
import { toAbsoluteUrl } from "../../../theme";
import "../../../theme/_assets/sass/pages/login/login-1.scss";

 function AuthPage(props) {
  return (
    <>
      {/* https://github.com/nfl/react-helmet */}
      <Helmet>
        {/* <link
            type="text/css"
            rel="stylesheet"
            href={toAbsoluteUrl(
                "/assets/css/demo1/style.bundle.css"
            )}
        />
        <link
          type="text/css"
          rel="stylesheet"
          href={toAbsoluteUrl(
            "/assets/css/demo1/pages/login/login-1.css"
          )}
        /> */}
      </Helmet>

      <div className="kt-grid kt-grid--ver kt-grid--root">
        <div
          id="kt_login"
          className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
        >
          <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
            <div
              className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
              style={{
                backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-3.jpg")})`
              }}
            >
              <div className="kt-grid__item">
                <Link to="/" >
                {/* <center><img
                    alt="Logo"
                    src={toAbsoluteUrl("/media/logos/GoWatr12.png")}
                  />
                  </center> */}
                
                </Link>
              </div>
              <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                <div className="kt-grid__item kt-grid__item--middle">
                  <div>
                  {/* <h3 className="kt-login__title" style={{textAlign:'center',wordSpacing:'20px'}}><center>&nbsp; Welcome    to <img
                    alt="Logo"
                    src={toAbsoluteUrl("/media/logos/logo-light.png")}
                  /></center>
                  </h3> */}
                  </div>
                </div>
              </div>
              <div className="kt-grid__item">
                <div className="kt-login__info">
                  <div className="kt-login__copyright">&copy; 2019 GoWater</div>
                  <div className="kt-login__menu">
                    {/* <Link to="/terms" className="kt-link">
                      Privacy
                    </Link>
                    <Link to="/terms" className="kt-link">
                      Legal
                    </Link>
                    <Link to="/terms" className="kt-link">
                      Contact
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
            {props.location.pathname == "/auth/login" && <Login></Login>}
{props.location.pathname == "/auth/forgot-password" && (
<ForgotPassword></ForgotPassword>
)}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(AuthPage);

